/**
 * @author Johann Esneider Casallas Becerra
 * @Copyright (c) Infotrack. All rights reserved.
 */

export default {
    // Alertas Maximos y Minimos

    'maximosMinimos.inputAlerta.nombreProducto' : 'El campo Nombre Producto se encuentra vacío. Por favor, verifique la información',
    'maximosMinimos.inputAlerta.valorMinimoInvalido' : 'Valor mínimo tiene que ser mayor a cero, verifica la información',
    'maximosMinimos.inputAlerta.valorMaximoInvalido' : 'Valor máximo tiene que ser mayor a cero, verifica la información',
    'maximosMinimos.inputAlerta.valorMinimoMayor' : 'Valor mínimo no puede ser mayor que valor máximo',

    // Gestion Maximos Minimos

    'maximosMinimos.CodigoProducto': 'Código Producto',
    'maximosMinimos.agregarMaximosMinimos': 'Agregar Máximos y Mínimos',
    'maximosMinimos.editarMaximosMinimos': 'Editar Máximos y Mínimos',
    'maximosMinimos.NombreProducto': 'Nombre Producto',
    'maximosMinimos.NivelMinimo': 'Nivel Minimo',
    'maximosMinimos.NivelMaximo': 'Nivel Maximo',
};
